import { render } from "./GenerateTokenForLinkAccountantModal.vue?vue&type=template&id=c4c4e554&scoped=true"
import script from "./GenerateTokenForLinkAccountantModal.vue?vue&type=script&lang=js"
export * from "./GenerateTokenForLinkAccountantModal.vue?vue&type=script&lang=js"

import "./GenerateTokenForLinkAccountantModal.vue?vue&type=style&index=0&id=c4c4e554&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c4e554"]])

export default __exports__